import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("vm_token", data.token);
      toast.success("Welcome back, Admin");
      nav("/admin");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="App min-h-screen flex items-center justify-center relative px-5">
      <div className="vm-grain" />
      <div className="w-full max-w-sm relative z-10 vm-fade-up">
        <div className="flex items-center gap-2.5 justify-center mb-8">
          <img src="/logo-ddl.png" alt="Digital Dime Lab" className="w-8 h-8" />
          <span className="font-head text-xl tracking-tight font-semibold">DIGITAL DIME<span className="text-zinc-500"> LAB</span></span>
        </div>
        <div className="vm-glass rounded-2xl p-8">
          <h1 className="font-head text-2xl tracking-tight">Admin sign in</h1>
          <p className="text-sm text-zinc-500 mt-1">Manage products & orders</p>
          <form onSubmit={submit} className="mt-7 space-y-4">
            <div>
              <label className="block text-xs text-zinc-500 mb-1.5">Email</label>
              <input data-testid="admin-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-zinc-950 border border-white/15 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:border-white/50 transition-colors" />
            </div>
            <div>
              <label className="block text-xs text-zinc-500 mb-1.5">Password</label>
              <input data-testid="admin-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                className="w-full bg-zinc-950 border border-white/15 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:border-white/50 transition-colors" />
            </div>
            <button data-testid="admin-login-submit" disabled={loading}
              className="w-full inline-flex items-center justify-center gap-2 bg-white text-black px-6 py-3 rounded-md font-medium hover:bg-zinc-200 transition-colors disabled:opacity-60">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
